<div class="added-member-content-wrap">
  <div class="text">
    {{
      (canEditAccess()
        ? 'tlc.members.add_member.form.existing_member_info.heading'
        : 'tlc.members.add_member.form.existing_member_info.heading_no_edit_access'
      ) | translate
    }}
  </div>
  <rt-box class="member-box">
    <div class="member-info">
      <rt-avatar type="initials" [initials]="initials()" [context]="'admin'" />
      <span>{{ fullName() }}</span>
    </div>
    @if (canEditAccess()) {
      <rt-button (click)="editAccess.emit(member().guid)" variant="secondary">
        <rt-icon name="open-in-new" />
        <span>{{ 'tlc.members.add_member.form.existing_member_info.cta' | translate }}</span>
      </rt-button>
    }
  </rt-box>
</div>
